import { render, staticRenderFns } from "./PhoneVerify.vue?vue&type=template&id=5752e464&scoped=true&"
import script from "./PhoneVerify.vue?vue&type=script&lang=js&"
export * from "./PhoneVerify.vue?vue&type=script&lang=js&"
import style0 from "./PhoneVerify.vue?vue&type=style&index=0&id=5752e464&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752e464",
  null
  
)

export default component.exports